/*
  This file was named policy.d.ts.  But named as such, TS could not find the file when compiling.
  I renamed it to ewpolicy, now everything magically works.
  WTF?
*/



/**
 * enumerates object type ids for object to which policy can apply.
 * note that  this does not equate directly to the objecttypeoptions enum in .net. 
 * .net is more specific, whereas the services in _service/ewpolicy will map using the objecttype and user->role.
 */
export enum PolicyObjectTypeOptions {
  
  root = 0,
  servicelocation = 1,
  user = 2,
  member = 3,
  attendant = 4,
  serviceplan = 5,
  owner = 6,
  admin = 7,
  salesperson = 8,
  account_manager = 9,
  api = 10,
  support = 11
};

export const PolicyObjectCN = (opt: PolicyObjectTypeOptions): string => {

  switch (opt) {
    case PolicyObjectTypeOptions.root: return "objecttype.root"; break;
    case PolicyObjectTypeOptions.servicelocation: return "objecttype.servicelocation"; break;
    case PolicyObjectTypeOptions.user: return "objecttype.user"; break;
    case PolicyObjectTypeOptions.member: return "objecttype.member"; break;
    case PolicyObjectTypeOptions.attendant: return "objecttype.attendant"; break;
    case PolicyObjectTypeOptions.serviceplan: return "objecttype.serviceplan"; break;
    case PolicyObjectTypeOptions.owner: return "objecttype.owner"; break;
    case PolicyObjectTypeOptions.admin: return "objecttype.admin"; break;
    case PolicyObjectTypeOptions.salesperson: return "objecttype.salesperson"; break;
    case PolicyObjectTypeOptions.account_manager: return "objecttype.account_manager"; break;
    case PolicyObjectTypeOptions.api: return "objecttype.api"; break;
    case PolicyObjectTypeOptions.support: return "objecttype.support"; break;
    default: return "";
  }
}


/**
 * Defines a policy as applied to an object of type IPolicyObject.
 */
export interface IPolicy {

  /** The Policy identifier */
  policy_cn: string,
  /** The Policy context.. Not valued for policies that don't use context */
  context?: string,
  /** don't need to pass the full uri, just the term part */
  term: string,
  /** The Policy Value */
  value: string | null;
};

/**
 * Defines the 
 */
export interface IPolicyRequest {
  policy_cn: string,
  term: string,
  context?: string,
  when?: Date
};

/**
 * Use to assert that a policy must equal a certain value.  Any method that receives a policyassertion
 * must use the policy system to check for expected value.
 */
export interface IPolicyAssertion {
  policy: IPolicyRequest,
  expected: string
};

export interface IPolicyObject {
  id?: number,
  policies?: IPolicy[] | null,
  objectType: PolicyObjectTypeOptions,
  displayName?: string
};

export interface IPolicyQuery_DTO {
  policy_cn: string,
  param_cn: string,
  object_id: number,
  object_type_cn: string,
  context?: string,
  when?: Date
};

export interface IPolicyTermDefinition {
  param_cn: string;
  name: string;
  selector_cn: string;
  description: string;
}
export interface IPolicyDefinition {
  policy_cn: string;
  name: string;
  keep_history: number;
  description: string;
  traverse: string;
  terms: IPolicyTermDefinition[];
}

export interface IObjectPolicyTerm {
  param_cn: string;
  param_value: string;
}
export interface IObjectPolicy {
  id: number | null;
  object_type_cn: string;
  context: string;
  object_id: number;
  policy_cn: string;
  comments: string;
  terms: IObjectPolicyTerm[];
  editing?: boolean;
  disabled?: boolean;
}
